import reactifyWc from 'reactify-wc';
/**
 * Creates a React component proxy (wrapper) around an HTML element or custom element).
 * @param name The name of the HTML element to create.
 * @param options
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createElementProxy(name, options) {
    return reactifyWc(name, options);
}
